module.exports = __webpack_public_path__ + "static/img/89889688147bd7575d6327160d64e760.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 2761
// module chunks = 0